(function () {
  'use strict';

  var luckyPages = [
    '/blogs/archive/getaroom24',
    '/pages/mp3',
    '/blogs/archive/getaroom23',
    '/blogs/archive/saidali-mesbahi-interview',
    '/blogs/archive/josie-girand-interview',
    '/blogs/archive/alirq',
    '/blogs/archive/kinkygirlsfrombigcities',
    '/blogs/archive/getaroom20',
    '/blogs/archive/72',
    '/blogs/archive/getaroom18',
    '/blogs/archive/curtis-everett-pawley',
    '/blogs/archive/lowertown-interview',
    '/blogs/archive/69',
    '/blogs/archive/silicone-valley',
    '/blogs/archive/besarta',
    '/blogs/archive/65',
    '/blogs/archive/anok-yai-alex-consani',
    '/blogs/archive/57',
    '/blogs/archive/annual-report',
    '/blogs/archive/no-erotica',
    '/blogs/archive/45',
    '/blogs/archive/getaroom10',
    '/blogs/archive/2holliswarsaw',
    '/blogs/archive/bars',
    '/blogs/archive/berlin',
    '/blogs/archive/21',
    '/blogs/archive/edbanger',
    '/blogs/archive/12',
    '/blogs/archive/a-night-of-decadance',
    '/blogs/archive/23',
    '/blogs/archive/a-night-of-sleaze-the-hellp-instupendo-damon-r-and-extra-small-bowery-ballroom',
    '/blogs/archive/thedavre-nyfw',
    '/blogs/archive/the-drone-of-humanity',
    '/blogs/archive/garrison-conversations-about-nothing',
    '/blogs/archive/vince-conversations-about-nothing',
    '/blogs/archive/emma-conversations-about-nothing',
    '/blogs/archive/machai-interview',
    '/blogs/archive/kev-creature-interview',
  ];

  function goRandom(e) {
    if (e) e.preventDefault();
    var page = luckyPages[Math.floor(Math.random() * luckyPages.length)];
    window.location.href = page;
  }

  window.NRLucky = {
    pages: luckyPages,
    go: goRandom,
    bind: function (selector) {
      var nodes = document.querySelectorAll(selector);
      nodes.forEach(function (node) {
        if (node.dataset.nrLuckyBound) return;
        node.dataset.nrLuckyBound = '1';
        node.addEventListener('click', goRandom);
      });
    },
  };
})();
